export default __webpack_public_path__ + "static/media/logoFull.0f21c7e6.jpg";